import { render, staticRenderFns } from "./teacherFeatured.vue?vue&type=template&id=45839cec&scoped=true"
import script from "./teacherFeatured.vue?vue&type=script&lang=js"
export * from "./teacherFeatured.vue?vue&type=script&lang=js"
import style0 from "./teacherFeatured.vue?vue&type=style&index=0&id=45839cec&prod&lang=scss"
import style1 from "./teacherFeatured.vue?vue&type=style&index=1&id=45839cec&prod&scoped=true&lang=scss"
import style2 from "./teacherFeatured.vue?vue&type=style&index=2&id=45839cec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45839cec",
  null
  
)

export default component.exports